const vanBangBanSaoState = {
  none: 0,
  choDuyet: 1,
  daDuyet: 2,
}
const getVanBangBanSaoState = (value) => {
  switch (value) {
    case vanBangBanSaoState.choDuyet:
      return 'Chờ duyệt'
    case vanBangBanSaoState.daDuyet:
      return 'Đã duyệt'
    default:
      return 'Trạng thái'
  }
}

export default vanBangBanSaoState
export { getVanBangBanSaoState }
